import { Navigate, Outlet, useLocation, useRevalidator } from 'react-router-dom';

import { AccessProvider } from '../access';
import { OnboardingGate } from '../modules/onboarding';
import { PASSCODE_ROUTES } from '../navigation/paths';
import { SessionCheckFailed, SessionChecking, SignedInSessionProvider, useServerSession } from '../session';

/** Every signed-in page sits behind the server's answer to who is signed in — never behind anything the browser stored. */
export default function AuthenticatedRoute() {
    const session = useServerSession();
    const { revalidate } = useRevalidator();
    const location = useLocation();
    if (session.status === 'pending') return <SessionChecking paused={session.paused} />;
    if (session.status === 'failed') return <SessionCheckFailed error={session.error} onRetry={session.retry} />;
    if (session.status === 'signedOut') {
        const returnTo = session.reason === 'loggedOut' ? undefined : { from: location.pathname + location.search };
        return <Navigate to={PASSCODE_ROUTES.login} replace state={returnTo} />;
    }
    return (
        <SignedInSessionProvider session={session}>
            <AccessProvider onAccessChanged={revalidate}>
                <OnboardingGate>
                    <Outlet />
                </OnboardingGate>
            </AccessProvider>
        </SignedInSessionProvider>
    );
}
